import { SegmentedControl, SegmentedControlProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { ResourceTypeCategory } from "../../../../@client/Theasoft_DataClasses_Dispo"

interface Props extends Omit<SegmentedControlProps, "data"> {
  category: ResourceTypeCategory
}

export function ResourceObjectsSegmentControl({ category, ...props }: Props) {
  const { t } = useTranslation("app_server")
  return (
    <SegmentedControl
      data={[
        {
          value: "Resources",
          label: t(`ResourceCategory_${category}`),
        },
        {
          value: "Objects",
          label: t(`ResourceObjectCategory_${category}`),
        },
      ]}
      {...props}
    />
  )
}
